import styled from 'styled-components'
import React, { Component, FC, MutableRefObject, Ref, useRef } from 'react'
import { Cross } from './icons/Cross'
import { useOnClickOutside } from '../../hooks/rendering'

interface PopupProps {
  outsideRef: Ref<any>
  onExit: VoidFunction
  children: any
  title?: string
  removePadding?: boolean
}

export const Popup: FC<PopupProps> = props => {
  useOnClickOutside(props.outsideRef, props.onExit)

  return (
    <PanelPopup ref={props.outsideRef} data-cy={'swaap-popup'}>
      <Top>
        <H2>{props.title}</H2>
        <Cross onClick={props.onExit} />
      </Top>
      <div>
        {props.removePadding ? (
          <div>{props.children}</div>
        ) : (
          <Padder>{props.children}</Padder>
        )}
      </div>
    </PanelPopup>
  )
}

const Top = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-left: 2rem;
  padding-right: 2rem;
`

const Padder = styled.div`
  padding-left: 1.75rem;
  padding-right: 1.75rem;
`

const H2 = styled.h2`
  font-family: Montserrat-Light;
  font-size: 1.5rem;
  padding: 0;
  margin: 0;
`

export const PanelPopup = styled.div`
  position: relative;
  top: 0;
  text-align: center;
  overflow: auto;
  align-self: center;
  color: ${({ theme }) => theme.swapCurrencySelectorPanelTextColor};
  background-color: ${({ theme }) =>
    theme.swapCurrencySelectorPanelBackgroundColor};
  border-radius: 35px;
  padding: 10px 0 15px;
  display: flex;
  flex-direction: column;

  /* Tablets */
  @media (max-width: 1400px) {
    //    	width: 60%;
  }

  /* Mobiles */
  @media (max-width: 640px) {
    //    	width: 95%;
  }
`
